import { render, staticRenderFns } from "./DepositoShow.vue?vue&type=template&id=6912b70a"
import script from "./DepositoShow.vue?vue&type=script&lang=js"
export * from "./DepositoShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports